<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  showLabel: { type: Boolean, default: true },
  src: { type: String, default: '' },
  name: { type: String, default: '' },
});
const emit = defineEmits(['change', 'delete']);
const { t } = useI18n();
const fileInput = ref(null);
const updateProfilePicture = event => {
  const [file] = event.target.files;
  if (file) emit('change', { file, url: URL.createObjectURL(file) });
};
const deleteProfilePicture = () => {
  fileInput.value.value = '';
  emit('delete');
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <span v-if="showLabel" class="text-sm font-medium text-n-slate-12">
      {{ t('PROFILE_SETTINGS.FORM.PICTURE') }}
    </span>
    <div class="flex flex-wrap items-center gap-4">
      <Avatar :src="src || ''" :name="name || ''" :size="80" rounded-full />
      <input
        ref="fileInput"
        type="file"
        accept="image/*"
        class="hidden"
        :aria-label="t('SETTINGS_NAV.UPLOAD_PHOTO')"
        @change="updateProfilePicture"
      />
      <Button
        icon="i-lucide-camera"
        variant="outline"
        size="sm"
        :label="t('SETTINGS_NAV.UPLOAD_PHOTO')"
        @click="fileInput?.click()"
      />
      <Button
        v-if="src"
        icon="i-lucide-trash-2"
        color="ruby"
        variant="ghost"
        size="sm"
        :label="t('SETTINGS_NAV.REMOVE_PHOTO')"
        @click="deleteProfilePicture"
      />
    </div>
  </div>
</template>
